export default __webpack_public_path__ + "static/media/menu.26969a5f.svg";